// import { getCatchAddress, setCatchAddress } from '@utils/locationApi/location';
import { setCatchAddress, getCatchAddress } from 'dflocationsdk';
import Cookies from 'js-cookie';

/**
 * 判断是否是百福德环境
 */
export function BFD_checkApp() {
    return window.navigator.userAgent.indexOf('BFD-APP') > -1 || window.navigator.userAgent.indexOf('MAX-APP') > -1
}


/**
 * 判断是否是官网app
 */
export function DF_checkApp() {
    return window.navigator.userAgent.indexOf('MAX-APP') > -1
}

/**
 * 加载js依赖文件
 */
export function loadFUNJS() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = '//static.dongfangfuli.com/info/bridge/1.0/prd/app_bridge.min.js';
    document.head.appendChild(script);
    console.log('loadFUNJS11')
}
var timeFun;
/**
 * 跳转至app页面
 * @param {*} pathKey 原生页面key
 *  'city'        //城市选择页
    'user'        //个人中心页
    'userdetail'  //个人详情
    'balance'     //账户余额
    'setting'     //设置页
    'about'       //关于
    'feedback'    //意见反馈
 */
export function BFD_goToAppPage(pathKey) {
    try {
        if (timeFun) {
            clearTimeout(timeFun)
        }
        timeFun = setTimeout(() => {
            const params = {
                pageName: pathKey,
                pageData: ''
            }
            console.log('跳转原生', window.dfwAppclass)
            window.dfwAppclass.DFWUtils.appShowPage(params, function (respData) {
                var infoStr = JSON.stringify(respData)
                console.log('appShowPage', infoStr)
            })
        }, 200);
    } catch (e) {
        console.log('跳转原生异常', e)
        return false;
    }
    return true;
}
export function BFD_LoginOut() {
    try {
        const params = {
            type: 'tokenTimeout',
        }
        console.log('跳转登陆页', window.dfwAppclass)
        window.dfwAppclass.DFWUtils.appRelogin(params, function (respData) {
            var infoStr = JSON.stringify(respData)
            console.log('appRelogin', infoStr)
        })
    } catch (e) {
        console.log('跳转登陆页', e)
        return false;
    }
    return true;
}
export function BFD_appBackToStorehome(pathKey) {
    try {
        if (timeFun) {
            clearTimeout(timeFun)
        }
        timeFun = setTimeout(() => {
            window.dfwAppclass.DFWUtils.appBackToStorehome()
        }, 200);
    } catch (e) {
        console.log('跳转原生异常', e)
        return false;
    }
    return true;
}
export function BFD_changeAppAddress(city, cityId) {
    console.log(`city${city},cityId${cityId}`)
    try {
        const params = {
            'city': city,     //城市名     必填
            'cityId': cityId    //城市id    必填
        }
        window.dfwAppclass.DFWCity.appSwitchCityInfo(params, function (respData) {
            var infoStr = JSON.stringify(respData)
            console.log('appRelogin', infoStr)
        })
    } catch (e) {
        console.log('更改原生地址异常', e)
        return false;
    }
    return true;
}

export function BFD_appGetCityInfo() {
    try {
        dfBrid.DFWCity.appGetCityInfo(function (respData) {
            console.log('appRelogin', respData)
            console.log('bridge', respData)
            const add = Cookies.get('address')
            if (!add) {
                Cookies.set(
                    'address',
                    respData.data.address,
                    { expires: 365 },
                );
            }
            const localAddress = JSON.parse(getCatchAddress()) || null;
            if (!localAddress || !localAddress.cityId || localAddress?.streetId != respData.data.address?.streetId) {
                setCatchAddress(
                    respData.data.address.provinceId,
                    respData.data.address.provinceName,
                    respData.data.address.provinceName,
                    respData.data.address.cityId,
                    respData.data.address.cityName,
                    respData.data.address.cityName,
                    respData.data.address.regionId,
                    respData.data.address.regionName,
                    respData.data.address.regionName,
                    respData.data.address.streetId,
                    respData.data.address.streetName,
                    respData.data.address.streetName,
                    respData.data.address?.id ? respData.data.address?.id : '',
                )
            }
            return respData.data.address;
        }) 
    } catch (e) {
        console.log('更改原生地址异常', e)
        return {};
    }
}
